import { useCallback, useContext, useEffect, useRef } from "react"
import Utils from '@utils/utils'
import { message } from "antd"
import API from '@api/api'
import axios from 'axios';
import eventBus from '@utils/eventBus';
import { fabric } from 'fabric'

// 将mask白色部分转为蓝色透明
function convertWhiteImageToBlue(base64Data) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Data;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;
      
      for (let i = 0; i < pixels.length; i += 4) {
        const red = pixels[i];
        const green = pixels[i + 1];
        const blue = pixels[i + 2];
        const alpha = pixels[i + 3];
          // Set non-black pixels to rgba(30, 144, 255, 0.8)
        if (red==255 && green==255 && blue==255 && alpha==255) {
            pixels[i] = 30;
            pixels[i + 1] = 144;
            pixels[i + 2] = 255;
            pixels[i + 3] = 204;
        }
      }
      
      ctx.putImageData(imageData, 0, 0);
      const convertedData = canvas.toDataURL();

      resolve(convertedData);
    };
    
    img.onerror = (error) => {
      reject(error);
    };
  });
}

const useMultiInteractive = (props) => {
    const {instance, topInstance} = props
    const modeRef = useRef(props.interactiveMode)

    useEffect(() => {
        modeRef.current = props.interactiveMode
    }, [props.interactiveMode])

    useEffect(() => {
        if (!instance) return
        topInstance.on('mouse:down', (ev) => {
            if (!modeRef.current) return
            // 备份用于撤销
            props.addUndo('interactive')
            if (modeRef.current == 'add' || modeRef.current == 'init') {
                ev.target && addMaskSlice(ev.target)
            } else {
                ev.target && removeMaskSlice(ev.target)
            }
        })
        topInstance.on('mouse:over', ev => {
            if (!modeRef.current) return
            if (ev && ev.target) {
                ev.target.opacity = 1
                topInstance.renderAll()
            }
        })
        topInstance.on('mouse:out', ev => {
            if (ev && ev.target) {
                ev.target.opacity = .01
                topInstance.renderAll()
            }
        })
    }, [instance])

    const displayScaleRef = useRef(props.displayScale)
    useEffect(() => {
        displayScaleRef.current = props.displayScale
    }, [props.displayScale])

    const addMaskSlice = (img) => {
        img.clone(clone => {
            clone.set({
                evented: false,
                width: clone.width,
                height: clone.height,
            })
            clone.scale(displayScaleRef.current)
            clone.filters.push(new fabric.Image.filters.ReplaceColor({
                color: 'rgb(30, 144, 255)',
                replacementColor: [255, 255, 255, 255]
            }))
            clone.applyFilters();
            const objects = instance.getObjects()
            const tempCanvas = new fabric.StaticCanvas(null, {
                width: instance.width,
                height: instance.height
            })
            tempCanvas.add(...objects, clone)
            const mask = tempCanvas.toDataURL({ format: 'png', multiplier: 1 / displayScaleRef.current });
            convertWhiteImageToBlue(mask).then(blueMask => {
                props.setBlueMaskBase64(blueMask)
                instance.remove(...objects.filter(item => item.type == 'path'))
            })
        })
    }

    const removeMaskSlice = (img) => {
        img.clone(clone => {
            clone.set({
                opacity: 1,
                globalCompositeOperation: 'destination-out',
                evented: false,
                width: clone.width,
                height: clone.height,
            })
            clone.scale(displayScaleRef.current)
            clone.filters.push(new fabric.Image.filters.ReplaceColor({
                color: 'rgb(30, 144, 255)',
                replacementColor: [255, 255, 255, 255]
            }));
            clone.applyFilters();
            const objects = instance.getObjects()
            const tempCanvas = new fabric.StaticCanvas(null, {
                width: instance.width,
                height: instance.height
            })
            tempCanvas.add(...objects, clone)
            const mask = tempCanvas.toDataURL({ format: 'png', multiplier: 1 / displayScaleRef.current });
            props.setBlueMaskBase64(mask)
            instance.remove(...objects.filter(item => item.type == 'path'))
        })
    }

    useEffect(() => {
        if (!instance) return
        const list = props.multiMasks.map(item => Utils.loadImageUrlByFabric(item.image_path_base64))
        Promise.all(list).then(imgList => {
            for (let i = 0; i < imgList.length; i++) {
                const img = imgList[i]
                img.scale(props.displayScale) // 背景展示完全
                img.set({
                    opacity: .01,
                    hoverCursor: 'pointer',
                    perPixelTargetFind: true,
                    hasControls: false,
                    hasBorders: false,
                    selectable: false,
                })
                img.set('unclearable', true)
                img.set('is_mask_slice', true)
                try {
                    topInstance.add(img)
                    topInstance.requestRenderAll()
                } catch (err) {
                    console.error(err)
                }
            }
        })
    }, [props.multiMasks, instance])
}

export default useMultiInteractive